import { create } from 'zustand';

interface CartStore {
  cartActive: boolean;
  setCartActive: (active: boolean) => void;
  resetStore: () => void;
}

const initialState = {
  cartActive: false,
};

export const useCartStore = create<CartStore>((set) => ({
  ...initialState,
  setCartActive: (active: boolean) => set({ cartActive: active }),
  resetStore: () => set(initialState),
}));
